import { Button, Col, Form, FormLabel, Modal, Offcanvas, Row } from 'react-bootstrap';
import FeatherIcons from 'feather-icons-react';
import { FormInput, VerticalForm } from '../../components';
import Layout from './Layout';
import { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { CircularProgress, LinearProgress } from '@mui/material';
import { APICore } from '../../helpers/api/apiCore';
import { useHistory } from 'react-router';
import { BASIC_URL } from '../../config';
import logo from '../../assets/images/logo-bg-2.png';
import fileDownload from 'js-file-download'
import { isMobile } from 'react-device-detect';
import './style.css'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { IS_VALID_EMAIL } from '../../helpers/common';
import moment from 'moment';

// ================================AHMED
import { runOpenAI } from "./openai";

const apiCore = new APICore();

const CollovGbt = (props: any) => {

  // صورة المنتج القادمة من المتجر

const [productImage, setProductImage] = useState<string | null>(null);
const [productSku, setProductSku] = useState<string | null>(null);
const [showProduct, setShowProduct] = useState(true);


useEffect(() => {

  const params = new URLSearchParams(window.location.search);

  const sku = params.get("sku");
  const img = params.get("img");

  if (sku && img) {

    const decodedImg = decodeURIComponent(img);

    console.log("SKU FROM URL:", sku);
    console.log("IMAGE FROM URL:", decodedImg);

    setProductSku(sku);
    setProductImage(decodedImg);

  } else {

    console.log("NO PRODUCT ATTACHED");

    setProductSku(null);
    setProductImage(null);

  }

}, []);

  // زر صورة جديدة
const resetStates = () => {
  setGeneratedImages([]);
  setIsGenerating(false);

// حذف المنتج بالكامل من الجلسة
localStorage.removeItem("ai_img");
localStorage.removeItem("ai_sku");

setProductImage(null);
setProductSku(null);

};


 const [isGenerating, setIsGenerating] = useState(false);

 const [selectedRoom, setSelectedRoom] = useState("");
 const [selectedStyle, setSelectedStyle] = useState("");
 const [moodText, setMoodText] = useState("");

const handleGenerate = async () => {

  setIsGenerating(true);

  try {

    // المنتج اختياري
    if (!productSku || !productImage) {
      console.log("No product attached, generating normal design");
    }

const prompt = `
You are a professional interior designer.

Your task is to create a realistic interior design scene.

INPUT DATA:

Room type:
${roomType || "not specified"}

Design style:
${style?.value || "modern"}

Cultural identity:
${identity?.value || "neutral"}

User description:
${moodText || "no description provided"}

INSTRUCTIONS:

1. If a room image is provided, analyze the space layout, lighting, walls, and perspective.
2. If a product image is provided, the product MUST appear in the room.
3. Do NOT redesign the product — use it exactly as it appears.
4. Place the product naturally inside the room environment.
5. Match the furniture arrangement with the selected style.
6. Respect the cultural identity in colors, materials, and decoration.
7. Follow the mood described by the user.
8. Maintain realistic lighting, scale, and shadows.

GOAL:

Generate a realistic interior design image that looks like a professional interior photography.
`;

    console.log("SENDING:", {
      productSku,
      productImage
    });

let roomImageBase64 = undefined;

if (file) {
  const reader = new FileReader();

  roomImageBase64 = await new Promise((resolve) => {
    reader.onloadend = () => resolve(reader.result);
  reader.readAsDataURL(file.slice(0, file.size));

  });
}

const result = await runOpenAI({
  prompt,
  roomType,
  style: style?.value,
  identity: identity?.value,
  mood_text: description,
  roomImage: roomImageBase64 || undefined,   // ← التعديل هنا
  productSku: productSku || undefined,
  productImage: productImage || undefined
});

    console.log("AI RESULT:", result);

if (result.images && result.images.length > 0) {
  const imgs = result.images.map(
    (img: string) => `data:image/png;base64,${img}`
  );

  setGeneratedImages(imgs);

  if (result.image_urls && result.image_urls.length > 0) {
    await saveCustomerHistory(
      result.image_urls.join(";"),
      0
    );
  }

} else if (result.image_base64) {

      setGeneratedImages([
        `data:image/png;base64,${result.image_base64}`
      ]);
    }

  } catch (err) {
    console.error(err);
    alert("فشل توليد التصميم");
  } finally {
    setIsGenerating(false);
  }
};

//=================================================END

// جلب التوكن
useEffect(() => {
  getApiToken();
}, []);

// إعادة ضبط عند تغيير الاتجاه
useEffect(() => {
  if (window.screen.orientation) {
    window.screen.orientation.onchange = function () {
      setFurnituresCoordinates([]);
      setSmiliarProducts([]);
      setSelectedFurniture(null);
      setDownloading(false);
      setUpScaling(false);
      setSelectedImageIndex(-1);
      setSelectedHistoryImageIndex(-1);
    };
  }
}, []);

   

// إدارة تحميل أو مسح المنتج حسب الرابط
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const sku = params.get("sku");
  const img = params.get("img");

  if (sku && img) {
    setProductSku(sku);
    setProductImage(img);

    console.log("Product loaded from URL");
    console.log("SKU:", sku);
    console.log("IMG:", img);
  } else {
    setProductSku(null);
    setProductImage(null);

    console.log("Product cleared");
  }
}, []);



    const [generatedImages, setGeneratedImages] = useState<string[]>([]);  
    const [style, setStyle] = useState({ value: "", label: "" })
    const [roomType, setRoomType] = useState("")
    const [identity, setIdentity] = useState({ value: "", label: "" });
    
     const [iosVersion, setIosVersion] = useState("")
    const [androidVersion, setAndroidVersion] = useState("")
    const [startMode, setStartMode] = useState<'feeling' | 'explore' | null>(null);
    const [description, setDescription] = useState(''); 
    const [aiImageBase64, setAiImageBase64] = useState<string | null>(null);
    
    const [showMenu, setShowMenu] = useState(false)
    const [showInstructions, setShowInstructions] = useState(false)
    const [showImagesHistory, setShowImagesHistory] = useState(false)
    const [isGeneratingFurnitureMarks, setIsGeneratingFurnitureMarks] = useState(false)
    const [isDownloading, setDownloading] = useState(false)
    const [isUpScaling, setUpScaling] = useState(false)
    const [isCanUpscale, setCanUpscale] = useState(false)

    const [images, setImages] = useState<string[]>([]);

    const [file, setFile] = useState<any>(null)
    const [furnituresCoordinates, setFurnituresCoordinates] = useState<any[]>([])
    const [newStyles, setNewStyles] = useState<any[]>([])
    const [customerHistoryImages, setCustomerHistoryImages] = useState<any[]>([])
    const [selectedImageIndex, setSelectedImageIndex] = useState(-1)
    const [selectedHistoryImageIndex, setSelectedHistoryImageIndex] = useState(-1)
    const [user, setUser] = useState<any>(null)
    const history = useHistory();
    const [similarProducts, setSmiliarProducts] = useState<string[]>([]);
    const [isSearchingSimilarProducts, setSearchingSimilarProducts] = useState(false)
    const [isUpdating, setUpdating] = useState(false)
    const [isAlreadyUpscaled, setAlreadyUpScaled] = useState(false)
    const [isCheckingAuth, setCheckingAuth] = useState(true)
    const [selectedFurniture, setSelectedFurniture] = useState<any>(null)
    const [recordId, setRecordId] = useState<number>(0)
    const [upscaledImageUrl, setUpscaledImageUrl] = useState<string>("")
    const [showAddShortsModal, setShowAddShortsModal] = useState(false)
    const [showMobileVersionModal, setShowMobileVersionModal] = useState(false)

    // SHORTS

    const [idCategory, setCategoryId] = useState<string>("")
    const [selectedShortId, selectShortId] = useState<number>(-1)
    const [shortUrl, setShortUrl] = useState<string>("")
    const [productUrl, setProductUrl] = useState<string>("")
    const [shorts, setShorts] = useState<object[]>([]);
    const [categories, setCategories] = useState<object[]>([]);

    const imgRef = useRef(null);
    const { enqueueSnackbar } = useSnackbar()
    const roomTypesData = [
        { value: "living room", label: "غرفة جلوس", image: "/roomType/living_room.jpeg" },
        { value: "dining room", label: "غرفة طعام", image: "/roomType/dining_room.jpeg" },
        { value: "bedroom", label: "غرفة نوم", image: "/roomType/bedroom.jpeg" },
        { value: "children's room", label: "غرفة اطفال", image: "/roomType/kids_room.jpeg" },
        { value: "family room", label: "غرفة المعيشة", image: "/roomType/family_room.jpeg" },
        { value: "bathroom", label: "حمام", image: "/roomType/bathroom.jpeg" },
        { value: "kitchen", label: "مطبخ", image: "/roomType/kitchen.jpeg" },
        { value: "office", label: "مكتب منزلي", image: "/roomType/home_office.jpeg" },
        { value: "hallway", label: "ممر المنزل", image: "/roomType/home_hallway.jpeg" },
        { value: "entrance hall", label: "مدخل المنزل", image: "/roomType/home_entrance.jpeg" },
        { value: "storage room", label: "غرفة التخزين", image: "/roomType/storage_room.jpeg" },
        { value: "cloak room", label: "غرفة ملابس", image: "/roomType/walk-in_closet.jpeg" },
        { value: "open office area", label: "مكتب مفتوح", image: "/roomType/office.jpeg" },
        { value: "meeting room", label: "غرف الاجتماعات", image: "/roomType/meeting_room.jpeg" },
        { value: "reception area", label: "الاستقبال", image: "/roomType/reception.jpeg" },
    ]
    const _styles = [
        { value: "bohemian", label: "البوهيمي", image: "/style2/bohemian.jpeg" },
        { value: "coastal", label: "ساحلية", image: "/style2/coastal.jpeg" },
        { value: "mid-century", label: "قرن", image: "/style2/mid_century.jpeg" },
        { value: "scandinavian", label: "اسكندنافي", image: "/style2/scandinavian.jpeg" },
        { value: "eclectic", label: "انتقائي", image: "/style2/eclectic.jpeg" },
        { value: "modern", label: "حديث", image: "/style2/modern.jpeg" },
        { value: "transitional", label: "انتقالية", image: "/style2/transitional.jpeg" },
        { value: "rustic", label: "ريفي", image: "/style2/rustic.jpeg" },
        { value: "classic", label: "كلاسيك", image: "/style2/classic.jpeg" },
    ]

const _identity = [
  { value: "global", label: "عالمي", image: "/identity/global.jpg" },
  { value: "saudi", label: "سعودي", image: "/identity/saudi.jpg" },
  { value: "gulf", label: "خليجي", image: "/identity/gulf.jpg" },
  { value: "arabic_luxury", label: "عربي فاخر", image: "/identity/arabic.jpg" },
]


        const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 5
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    const dropContainer = document.getElementById("dropcontainer")
    const fileInput = document.getElementById("images") as HTMLInputElement

    if (dropContainer) {
        dropContainer!.addEventListener("dragover", (e) => {
            e.preventDefault()
        }, false)

        dropContainer!.addEventListener("dragenter", () => {
            dropContainer!.classList.add("drag-active")
        })

        dropContainer!.addEventListener("dragleave", () => {
            dropContainer!.classList.remove("drag-active")
        })

        dropContainer!.addEventListener("drop", (e) => {
            e.preventDefault()
            dropContainer!.classList.remove("drag-active")
            if (fileInput) {
                fileInput.files! = e.dataTransfer!.files
            }
        })
    }

    async function getApiToken() {
    await axios.get("/api/api-token")        

    .then(response => {
                if (response.data.api_token) {
                    localStorage.setItem("api_token", response.data.api_token);
                    let email = props.match?.params?.email || ""
                    if (email && IS_VALID_EMAIL(email)) {
                        getCustomerByEmail(email)
                        getCustomerHistory()
                    } else {
                        checkAuth()
                    }
                } else {
                    setCheckingAuth(false)
                }
            })
            .catch(function (error) {
            })
    }

    function checkAuth() {

        let isUserAuthenticated = apiCore.isUserAuthenticated()
        if (isUserAuthenticated) {
            let customer = apiCore.getLoggedInUser()
            getCustomerByEmail(customer.email)
            getCustomerHistory()
        } else {
            setCheckingAuth(false)
        }
    }

    async function saveShort() {

        let apiToken = localStorage.getItem("api_token")
        let data = {
            category_id: idCategory,
            short_url: shortUrl,
            product_url: productUrl,
            apiToken: apiToken
        }
        await axios.post(BASIC_URL + "api/shorts/add", data)
            .then(response => {
                getShorts()
            })
            .catch(function (error) {
            })
    }

    async function updateMobileVersions() {

        let data = {
            ios: iosVersion,
            android: androidVersion,
        }
        await axios.post(BASIC_URL + "api/mobile-versions", data)
            .then(response => {
                handleToast("تم تحديث النسخ بنجاح", "success")
            })
            .catch(function (error) {
            })
    }

    async function deleteShort(short_id: number) {

        let apiToken = localStorage.getItem("api_token")
        let data = {
            short_id: short_id,
            apiToken: apiToken
        }
        await axios.post(BASIC_URL + "api/shorts/delete", data)
            .then(response => {
                getShorts()
            })
            .catch(function (error) {
            })
    }

    async function getShorts() {
        let apiToken = localStorage.getItem("api_token")
        await axios.get(BASIC_URL + "api/shorts/" + apiToken)
            .then(response => {
                setShorts(response.data.data)
            })
            .catch(function (error) {
            })
    }


    async function getMobileVersions() {
        await axios.get(BASIC_URL + "api/mobile-versions")
            .then(response => {
                setAndroidVersion(response.data.androidVersion)
                setIosVersion(response.data.iosVersion)
            })
            .catch(function (error) {
            })
    }

    async function getCategories() {
        let apiToken = localStorage.getItem("api_token")
        await axios.get(BASIC_URL + "api/shorts/categories/" + apiToken)
            .then(response => {
                setCategories(response.data.filter((category: any) => category.top === "1"))
            })
            .catch(function (error) {
            })
    }

    async function saveCustomerHistory(photos_url: string, recordId: number) {

        let apiToken = localStorage.getItem("api_token")

        let data = {
            customer_id: user?.customer_id,
            photos_url: photos_url,
            apiToken: apiToken,
            record_id: recordId
        }
        await axios.post(BASIC_URL + "api/customer/history/new", data)
            .then(response => {
                getCustomerHistory()
            })
            .catch(function (error) {
            })
    }

    async function getCustomerHistory() {

        let apiToken = localStorage.getItem("api_token")

        let customer = apiCore.getLoggedInUser()
        let data = {
            idCustomer: customer.customer_id,
            apiToken: apiToken
        }
        await axios.post(BASIC_URL + "api/customer/history/all", data)
            .then(response => {
                let imagesUrls: any[] = []
                response.data.history.forEach((item: any) => {
                    item.photos_url.split(";").forEach((image: string) => {
                        imagesUrls.push({ url: image, recordId: item.record_id })
                    });
                })
                setCustomerHistoryImages(imagesUrls)
            })
            .catch(function (error) { })
    }

    async function getCustomerByEmail(email: string) {

        let apiToken = localStorage.getItem("api_token")
        let data = {
            email: email,
            apiToken: apiToken
        }
        await axios.post(BASIC_URL + "api/customer", data)
            .then(response => {
                let customer = response.data.customer
                if (customer) {
                    apiCore.setLoggedInUser(customer)
                    setUser(customer)
                    if (customer?.shorts === "1") {
                        getShorts()
                        getMobileVersions()
                        getCategories()
                    }
                    history.replace('/ia')
                }
            })
            .catch(function (error) {
            })
        setUpdating(false)
        setCheckingAuth(false)
    }

    const send = async () => {


        // getGeneratedImages(9291)
        // return

        if (!user) {
            handleToast("سجل الدخول أولا", "error")
            return
        }

        //if (file === null) {
        //  handleToast("اختر صورة الغرفة", "error")
        //   return
        //}

        //if (style.value === "") {
        //   handleToast("اختر ستايل غرفتك", "error")
        //    return
        //}

        //if (roomType === "") {
        //  handleToast("اختر نوع الغرفة", "error")
        //   return
        //}

        // if (mode.value === null) {
        //     handleToast("اختر الوضع", "error")
        //     return
        // }

        setImages([])
        setRecordId(0)
        setAlreadyUpScaled(false)
        setIsGenerating(true)
        setTimeout(() => {
            const scrollingElement = (document.scrollingElement || document.body);
            scrollingElement.scrollTop = scrollingElement.scrollHeight;
        }, 500)
        var formDataa = new FormData();
        formDataa.append('image', file);
        const result = await axios.post(BASIC_URL + 'upload', formDataa, { headers: { 'Content-Type': 'multipart/form-data' } })
        if (!result?.data?.url) {
            handleToast('هناك مشكلة في رفع الصورة، المرجو المحاولة مجددا', "error")
            return
        }
        const formData = new FormData();
        formData.append("style", style.value)
        formData.append("roomType", roomType)
        formData.append("uploadUrl", result.data.url)
        // formData.append("requestId", style.requestId)
        formData.append("mode", "PRESERVED")
        generateImageApi(formData)
    };

    function handleToast(text: any, type: any) {

        enqueueSnackbar(text, { variant: type, anchorOrigin: { vertical: 'top', horizontal: 'right' } })
    }

    async function generateImageApi(data: object) {

        await axios.post("https://api.collov.ai/flair/enterpriseApi/collovAi/generateImage", data, {
            headers: {
                'apiKey': 'ck_5972F11907C5A474EC3E1DA3C15CCF3E',
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => {
                setRecordId(response.data.data.id)
                getGeneratedImages(response.data.data.id)
            })
            .catch(function (error) {
                handleToast(error.response?.data?.message, "error")
                setIsGenerating(false)
            })
    }

    async function getColloVStyles() {

        let url = "https://api.collov.ai/flair/enterpriseApi/collovAi/getAllStyleList"
        await axios.get(url, {
            headers: {
                'apiKey': 'ck_5972F11907C5A474EC3E1DA3C15CCF3E',
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                setNewStyles(response.data.data.map((item: any) => ({ value: item.value, label: item.name, image: item.url })))
            })
            .catch(function (error) {
            })
    }

    async function getUpscaledImageUrl(id: number, imgUrl: string) {

        let url = "https://api.collov.ai/flair/enterpriseApi/collovAi/getUpScale?id=" + id + "&imgUrl=" + imgUrl
        await axios.get(url, {
            headers: {
                'apiKey': 'ck_5972F11907C5A474EC3E1DA3C15CCF3E',
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                //console.log(response)
                if (response.data?.data?.generateUrl) {
                    //console.log("Upscaled image url received")
                    //console.log(response.data?.data)
                    setUpscaledImageUrl(response.data?.data?.generateUrl)
                } else {
                    setTimeout(() => {
                        //console.log("Getting upscaled image url")
                        getUpscaledImageUrl(id, imgUrl)
                    }, 2000)
                }
            })
            .catch(function (error) { })
    }

    async function getGeneratedImages(id: number) {

        let url = "https://api.collov.ai/flair/enterpriseApi/collovAi/getRecord?id=" + id
        await axios.get(url, {
            headers: {
                'apiKey': 'ck_5972F11907C5A474EC3E1DA3C15CCF3E',
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (response.data.data.status === "PENDING") {
                    setTimeout(() => {
                        getGeneratedImages(id)
                    }, 5000)
                } else if (response.data.data.status === "SUCCESS") {
                    setImages(JSON.parse(response.data.data.images))
                    decreaseCustomerBalance()
                    let images_urls = ""
                    JSON.parse(response?.data?.data?.images).map((image: any, index: number) => {
                        if (JSON.parse(response?.data?.data?.images).length - 1 === index) {
                            images_urls += image
                        } else {
                            images_urls += image + ";"
                        }
                    })
                    saveCustomerHistory(images_urls, id)
                    setIsGenerating(false)
                    setTimeout(() => {
                        const scrollingElement = (document.scrollingElement || document.body);
                        scrollingElement.scrollTop = scrollingElement.scrollHeight;
                    }, 1500)
                } else {
                    setIsGenerating(false)
                }
            })
            .catch(function (error) {
                handleToast(error.response?.data?.message, "error")
                setIsGenerating(false)
            })
    }

    async function getImageFurnitureDetails(url: string, index: number, width: any) {

        let _url = "https://api.collov.ai/flair/enterpriseApi/collovAi/listPosition?width=" + width + "&filePath=" + url
        await axios.get(_url, {
            headers: {
                'apiKey': 'ck_5972F11907C5A474EC3E1DA3C15CCF3E',
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => {
                setFurnituresCoordinates(response.data.data)
            })
            .catch(function (error) {
            })
        setIsGeneratingFurnitureMarks(false)
    }

    async function getSimilarFurniture(type: string, secondaryType: string) {

        setSearchingSimilarProducts(true)

        let formData = new FormData()
        formData.append("type", type)
        formData.append("secondaryType", secondaryType)
        formData.append("count", "10")
        await axios.post("https://api.collov.ai/flair/enterpriseApi/collovAi/listFurnitureForNewAi", formData, {
            headers: {
                'apiKey': 'ck_5972F11907C5A474EC3E1DA3C15CCF3E',
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response: any) => {
                setSmiliarProducts(response.data.data.list)
            })
            .catch(function (error) {
            })
        setSearchingSimilarProducts(false)
    }

    async function requestImageUpScaling(id: number, index: number) {

        let formData = new FormData()
        formData.append("id", id + "")
        formData.append("imgUrl", images[index])
        await axios.post("https://api.collov.ai/flair/enterpriseApi/collovAi/getUpScaleUrlByImg", formData, {
            headers: {
                'apiKey': 'ck_5972F11907C5A474EC3E1DA3C15CCF3E',
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response: any) => {
                getUpscaledImageUrl(id, images[index])
            })
            .catch(function (error) {
            })
    }


async function decreaseCustomerBalance() {

  // تحقق من المستخدم
  if (!user || !user.customer_id) {
    console.error("No logged in user. Balance not deducted.");
    return;
  }

  let apiToken = localStorage.getItem("api_token");

  let data = {
    customer_id: user.customer_id,
    apiToken: apiToken
  };

  try {
    const response = await axios.post(
      BASIC_URL + "api/decrease-balance",
      data
    );

    let new_balance = response.data.new_balance;

    if (new_balance !== undefined) {
      let _user = { ...user, ia_balance: new_balance };
      setUser(_user);
      apiCore.setLoggedInUser(_user);
    } else {
      handleToast(response.data.error, "error");
    }
  } catch (err) {
    console.error("Balance error:", err);
  }
}




    async function upscaleGeneratedImage() {

        setUpScaling(true)
        // handleDownload(upscaledImageUrl, new Date().getTime())
        download(upscaledImageUrl)

        // await axios.get("https://api.collov.ai/flair/enterpriseApi/postsGenerateRecord/getUpScaleUrl?id=" + recordId + "&type=aiGenerate&size=4x", {
        //     headers: {
        //         'apiKey': 'ck_5972F11907C5A474EC3E1DA3C15CCF3E'
        //     }
        // })
        //     .then(response => {

        //         if (response.data.data) {
        //             handleDownload(response.data.data, new Date().getTime())
        //         } else {
        //             handleToast("حدث خطأ غير متوقع.", "error")
        //             setUpScaling(false)
        //         }
        //     })
        //     .catch(function (error) {
        //         setUpScaling(false)
        //     })
    
}

async function onChangeImage(event: any) {
  const input = event?.target;
  const original: File | undefined = input?.files?.[0];

  if (!original) {
    setFile(null);
    setAiImageBase64(null);
    return;
  }

  const MAX_IMAGE_BYTES = 4 * 1024 * 1024;
  const MAX_DIMENSION = 2048;
  const allowedTypes = ["image/jpeg", "image/png", "image/webp"];

  const rejectImage = (message: string) => {
    setFile(null);
    setAiImageBase64(null);
    if (input) input.value = "";
    handleToast(message, "error");
  };

  if (!allowedTypes.includes(original.type)) {
    rejectImage("يرجى اختيار صورة JPG أو PNG أو WebP.");
    return;
  }

  try {
    let prepared: File = original;

    if (original.size > MAX_IMAGE_BYTES) {
      const image = await createImageBitmap(original);

      try {
        const scale = Math.min(
          1,
          MAX_DIMENSION / Math.max(image.width, image.height)
        );

        const canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round(image.width * scale));
        canvas.height = Math.max(1, Math.round(image.height * scale));

        const context = canvas.getContext("2d");
        if (!context) throw new Error("CANVAS_UNAVAILABLE");

        context.fillStyle = "#ffffff";
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0, canvas.width, canvas.height);

        let compressed: Blob | null = null;

        for (const quality of [0.85, 0.75, 0.65]) {
          compressed = await new Promise<Blob | null>((resolve) => {
            canvas.toBlob(resolve, "image/jpeg", quality);
          });

          if (compressed && compressed.size <= MAX_IMAGE_BYTES) break;
        }

        if (!compressed || compressed.size > MAX_IMAGE_BYTES) {
          rejectImage("الصورة كبيرة جدًا. يرجى اختيار صورة أصغر.");
          return;
        }

        prepared = new File(
          [compressed],
          original.name.replace(/\.[^.]+$/, "") + ".jpg",
          { type: "image/jpeg" }
        );
      } finally {
        image.close();
      }
    }

    const base64 = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result));
      reader.onerror = () => reject(new Error("IMAGE_READ_FAILED"));
      reader.readAsDataURL(prepared);
    });

    const canUpscale = await checkUpScalePossibility(prepared);

    setFile(prepared);
    setAiImageBase64(base64);
    setCanUpscale(canUpscale as boolean);

    console.log("ROOM_IMAGE_READY", {
      bytes: prepared.size,
      type: prepared.type
    });
  } catch (error) {
    console.error("ROOM_IMAGE_PREPARATION_FAILED", error);
    rejectImage("تعذر تجهيز الصورة. يرجى تجربة صورة أخرى.");
  }
}

    const handleImageLoad = () => {
        let image = document.getElementById('imgg')
        setIsGeneratingFurnitureMarks(true)
        getImageFurnitureDetails(selectedHistoryImageIndex !== -1 ? customerHistoryImages[selectedHistoryImageIndex].url : images[selectedImageIndex], selectedHistoryImageIndex !== -1 ? selectedHistoryImageIndex : selectedImageIndex, image?.clientWidth)
    };

    const getSimilarProductsBoxHeight = () => {
        let box = document.getElementById('similar_products')
        return box?.clientHeight || 0
    };

    const normalDownload = async (url: string, filename: number) => {

        setDownloading(true)
        await axios.get(url, { responseType: 'blob' })
            .then((res) => {
                if (res) {
                    fileDownload(res.data, filename + ".png")
                }
                setDownloading(false)
            })
        setDownloading(false)
    }

    function checkUpScalePossibility(_file: any) {

        const img = document.createElement("img");
        const promise = new Promise((resolve, reject) => {
            img.onload = () => {
                const width = img.naturalWidth;
                resolve(width <= 1080);
            };
            img.onerror = reject;
        });
        img.src = URL.createObjectURL(_file);
        return promise;
    }

async function download(url: string) {
  const link = document.createElement("a");
  link.href = url;
  link.download = "manzilikom-design.png";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

    function toDataURL(url: string) {

        return fetch(url)
            .then((response) => {
                return response.blob();
            })
            .then((blob) => {
                return URL.createObjectURL(blob);
            });
    }

    async function handleDownload(url: string, fileName: number) {

        axios({
            url,
            method: 'GET',
            responseType: 'blob',
            timeout: 999999999999999,
            maxContentLength: 2000000000,
            maxRedirects: 50
        })
            .then(response => {
                const href = window.URL.createObjectURL(response.data);
                const anchorElement = document.createElement('a');

                anchorElement.href = href;
                anchorElement.download = fileName.toString();

                if (typeof anchorElement.download === 'undefined') {
                    anchorElement.setAttribute('target', '_blank');
                }
                document.body.appendChild(anchorElement);
                anchorElement.click();

                document.body.removeChild(anchorElement);
                window.URL.revokeObjectURL(href);
                setDownloading(false)
                setUpScaling(false)
            })
            .catch(async (error) => {
                setDownloading(false)
                setUpScaling(false)
            });
    }

    function hideModal() {

        setSelectedImageIndex(-1)
        setSelectedHistoryImageIndex(-1)
        setSelectedFurniture(null);
        setFurnituresCoordinates([]);
        setSmiliarProducts([]);
        setUpscaledImageUrl("")
        setDownloading(false);
        setUpScaling(false)
    }

    

    function logout() {
        apiCore.setLoggedInUser(null)
        setUser(null)
        setShowMenu(false)
    }

    if (isCheckingAuth) {
        return (
            <Layout openMenu={() => setShowMenu(true)} user={user}>
                <CircularProgress style={{ alignSelf: 'center' }} color="info" />
            </Layout >
        );
    }

   


return (
  <>
    <Layout openMenu={() => setShowMenu(true)} user={user} logout={() => logout()}>



{showProduct && productImage && (
  <img
    src={productImage}
    style={{
      width: 220,
      margin: "20px auto",
      display: "block",
      borderRadius: 12,
      border: "3px solid red"
    }}
  />
)}


<h4 style={{ fontWeight: 'bold', textAlign: 'center', paddingBottom: 15, color: "#5D290D" }}>اكتشف التصميم الذي يشبهك</h4>
           

                                 {user &&
                    <div className="d-flex justify-content-space-between">

                        <div style={styles.container1}>
                            <h3 style={styles.container2}>مرحبا <b>{user?.firstname}</b></h3>
                            <Button
                                onClick={() => window.open("https://manzilikom.com/index.php?route=product/product&product_id=542&search=%D8%B0%D9%83%D8%A7%D8%A1", "_blank")}
                                style={styles.balanceButton}>
                                <span style={{ textAlign: 'center' }}>اشحن رصيدك</span>
                                {/* <span style={{
                                textAlign: 'center', fontWeight: 'bold', letterSpacing: -1
                            }}>SAR</span> */}
                                {/* <FeatherIcons style={{ height: 21, paddingTop: 2, color: "white" }} color="white" icon={'dollar-sign'} className="icon-dual" /> */}
                            </Button>
                        </div>

                        <div style={styles.container3}>
                            <h3 style={styles.container2}>الرصيد الحالي</h3>
                            <Button
                                style={{ ...styles.balanceButton, width: '100%' }}>
                                <span>{user?.ia_balance} نقطة</span>
                            </Button>
                            {isUpdating && <LinearProgress color="error" style={{ height: 5 }} />}
                            <Button
                                onClick={() => {
                                    setUpdating(true)
                                    let customer = apiCore.getLoggedInUser()
                                    getCustomerByEmail(customer.email)
                                }}
                                className="mt-1"
                                style={styles.updateButton}>
                                <span style={{ textAlign: 'center', flex: 1 }}>تحديث</span>
                                <FeatherIcons style={{ height: 21, paddingTop: 2 }} icon={'refresh-ccw'} className="icon-dual" />
                            </Button>
                        </div>
                        {/*                     

                    <div style={styles.container3}>
                        <p style={{ fontSize: 16, textAlign: 'center' }}>الرصيد الحالي {isMobile ? <br /> : null}</p>
                        <p style={{ fontWeight: 'bold', paddingTop: 10, paddingBottom: 10, textAlign: 'center', backgroundColor: '#5D290D', color: 'white' }}>{user?.ia_balance} نقطة</p>
                       
                        <Button
                            onClick={() => {
                                setUpdating(true)
                                let customer = apiCore.getLoggedInUser()
                                getCustomerByEmail(customer.email)
                            }}
                            style={styles.updateButton}>
                            <span style={{ textAlign: 'center', flex: 1 }}>تحديث</span>
                            <FeatherIcons style={{ height: 21, paddingTop: 2 }} icon={'refresh-ccw'} className="icon-dual" />
                        </Button>
                        {/* <Button
                            onClick={() => window.open("https://manzilikom.com/index.php?route=product/product&product_id=542&search=%D8%B0%D9%83%D8%A7%D8%A1", "_blank")}
                            style={styles.balanceButton}>
                            <span style={{ textAlign: 'center', flex: 1 }}>اشحن</span>
                            <span style={{
                                textAlign: 'center', fontWeight: 'bold', letterSpacing: -1
                            }}>SAR</span>
                            {/* <FeatherIcons style={{ height: 21, paddingTop: 2, color: "white" }} color="white" icon={'dollar-sign'} className="icon-dual" /> */}
                        {/* </Button>  */}
                        {/* </div>  */}
                    </div>
                }

  <h4 style={{ fontWeight: 'bold', textAlign: 'center', paddingBottom: 15, color: "#5D290D" }}>كيف تحب تشعر في مساحتك</h4>
                           
                           <p
                            style={{
                              textAlign: 'center',
                              color: '#777',
                              fontSize: 14,
                              marginBottom: 20
                               }}
                            >
لا تحتاج ان تكون دقيقاً... أتبع احساسك فقط

</p>

{/* اختيار طريقة البدء */}
<div
  style={{
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    marginTop: 24,
    marginBottom: 24
  }}
>

  {/* الخيار الأساسي */}
  <div>
    <button
      type="button"
      onClick={() => setStartMode('feeling')}
      style={{
        background: startMode === 'feeling' ? '#FFF7F2' : '#FFF',
        border: '1px solid #E0D6CE',
        borderRadius: 14,
        padding: '16px 18px',
        fontSize: 16,
        fontWeight: 600,
        color: '#5D290D',
        cursor: 'pointer',
        width: '100%',
        textAlign: 'right',
        boxShadow: '0 4px 14px rgba(93,41,13,0.06)'
      }}
    >
      أحب أبدأ من إحساسي
    </button>

    <div
      style={{
        fontSize: 13,
        color: '#8A8A8A',
        marginTop: 6,
        lineHeight: '1.6',
        paddingRight: 6
      }}
    >
      اكتب إحساسك بحرية — جملة أو جملتين تكفي  
      <br />
      يمكنك الاكتفاء بالوصف فقط
    </div>
  </div>

  {/* مربع الوصف (الأساس) */}
  {startMode === 'feeling' && (
    <textarea
      value={description}
      onChange={e => setDescription(e.target.value)}
      placeholder="مثال: أجواء هادئة، ألوان دافئة، ولمسة مودرن بسيطة"
      style={{
        width: '100%',
        minHeight: 90,
        borderRadius: 12,
        border: '1px solid #E0D6CE',
        padding: 12,
        fontSize: 14,
        lineHeight: '1.6',
        resize: 'vertical'
      }}
    />
  )}

  {/* فاصل ذهني */}
  <div
    style={{
      fontSize: 12,
      color: '#999',
      textAlign: 'center'
    }}
  >
    أو يمكنك تحسين النتيجة بالخيارات التالية (اختياري)
  </div>

  {/* الخيار المساعد */}
<button
  type="button"
  onClick={() => setStartMode('explore')}
  onMouseEnter={(e) => {
    e.currentTarget.style.borderColor = '#5D290D'
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.borderColor = '#DDD'
  }}
  style={{
    background: 'transparent',
    border: '1px dashed #DDD',
    borderRadius: 10,
    padding: '10px 14px',
    fontSize: 14,
    fontWeight: 500,
    color: startMode === 'explore' ? '#5D290D' : '#777',
    cursor: 'pointer',
    textAlign: 'right',
    opacity: startMode === 'explore' ? 1 : 0.75,
    transition: 'all 0.2s ease'
  }}
>
  او استكشف بهدوء
</button>

</div>

{/* بداية هادئة */}
<p
  style={{
    textAlign: 'right',
    color: '#7A7A7A',
    fontSize: 14,
    marginBottom: 16
  }}
>
  خلّينا نبدأ بهدوء… خطوة خطوة
</p>

{/* خيار الصورة */}
<div style={{ marginBottom: 24 }}>

<h6
  style={{
    fontSize: 15,
    fontWeight: 600,
    marginBottom: 6,
    textAlign: 'right',
    color: '#333'
  }}
>
  صورة للمكان{' '}
  <span style={{ color: '#999', fontSize: 13, marginRight: 6 }}>
    (اختياري)
  </span>
</h6>

  <p
    style={{
      fontSize: 13,
      color: '#9A9A9A',
      marginBottom: 12,
      textAlign: 'right',
      lineHeight: '1.6'
    }}
  >
    {startMode === 'feeling'

      ? 'إن رغبت، يمكنك إضافة صورة لمساعدتنا على فهم المساحة بشكل أدق'
      : 'إن لم تُرفق صورة، سنقترح تصميمًا مبدئيًا كنقطة بداية'}
  </p>

<FormLabel
  htmlFor="images"
  id="dropcontainer"
  onMouseEnter={(e) => {
    if (!isMobile) {
      e.currentTarget.style.borderColor = '#5D290D'
    }
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.borderColor = '#E5DED8'
  }}
  style={{
    display: 'block',
    width: isMobile ? '100%' : '65%',
    minHeight: isMobile ? 120 : 180,
    margin: '0 auto',
    padding: 22,
    border: '2px dashed #E5DED8',
    borderRadius: 16,
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  }}
>

<div
  style={{
    fontSize: isMobile ? 14 : 16,
    color: '#5D290D',
    fontWeight: 600,
    marginBottom: 8
  }}
>
  اسحب صورة للمكان هنا
</div>

<div
  style={{
    fontSize: isMobile ? 12 : 14,
    color: '#999'
  }}
>
  أو اخترها من جهازك
</div>

    <FormInput
      type="file"
      name="file"
      id="images"
      accept="image/*"
      onChange={onChangeImage}
      style={{ display: 'none' }}
    />

    {file && (
      <img
        src={URL.createObjectURL(file)}
        alt=""
        style={{
          marginTop: 14,
          width: '100%',
          maxHeight: 220,
          objectFit: 'contain',
          borderRadius: 12
        }}
      />
    )}




  </FormLabel>
</div>

<h6 className="h6 mb-3 mt-3">
  ما نوع المساحة؟
  <span style={{ color: '#999', fontSize: 13, marginRight: 6 }}>
    (اختياري)
  </span>
</h6>            

    <Carousel
                    swipeable={true}
                    draggable={true}
                    showDots={true}
                    responsive={responsive}
                    ssr={true} // means to render carousel on server-side.
                    infinite={false}
                    autoPlay={false}
                    rtl={true}
                    autoPlaySpeed={1000}
                    keyBoardControl={true}
                    itemClass="itemStyle"
                    partialVisible={false}
                >
                    {roomTypesData.map(item =>
                        <div style={{
                            width: 150,
                            borderRadius: 20,
                            marginRight: 10,
                            overflow: 'hidden',
                            boxShadow: "0px 2px 2px 1px rgba(0, 0, 0, 0.2)",
                            border: item.value === roomType ? "5px solid #74331f" : "3px solid #fff"
                        }} onClick={() => setRoomType(item.value)}>
                            <img alt="" src={item.image} style={{
                                objectFit: "cover",
                                height: 100,
                                width: 150,
                            }} />
                            <p className="text-center" style={{ marginTop: 15 }}>{item.label}</p>
                        </div>
                    )}
                </Carousel>

<h6 className="h6 mb-3 mt-3">
  أي أسلوب يعبر عنك ؟
  <span style={{ color: '#999', fontSize: 13, marginRight: 6 }}>
    (اختياري)
  </span>
</h6>

                <Carousel
                    swipeable={true}
                    draggable={true}
                    showDots={true}
                    responsive={responsive}
                    ssr={true} // means to render carousel on server-side.
                    infinite={false}
                    autoPlay={false}
                    rtl={true}
                    autoPlaySpeed={1000}
                    keyBoardControl={true}
                    transitionDuration={500}
                    itemClass="itemStyle"
                    partialVisible={false}
                >
                    {_styles.map(item =>
                        <div style={{
                            width: 150,
                            borderRadius: 20,
                            marginRight: 10,
                            overflow: 'hidden',
                            boxShadow: "0px 2px 2px 1px rgba(0, 0, 0, 0.2)",
                            border: item.label === style.label ? "5px solid #74331f" : "3px solid #fff"
                        }}
                            onClick={() => setStyle({ label: item.label, value: item.value })}>
                            <img alt="" src={item.image} style={{ objectFit: "cover", height: 100, width: 150 }} />
                            <p className="text-center" style={{ marginTop: 15 }}>{item.label}</p>
                        </div>
                    )}
                </Carousel>

         
<h6 className="h6 mb-3 mt-3">
  أي هوية؟
  <span style={{ color: '#999', fontSize: 13, marginRight: 6 }}>
    (اختياري)
  </span>
</h6>

{console.log("IDENTITY:", _identity)}

<Carousel
  swipeable={true}
  draggable={true}
  showDots={true}
  responsive={responsive}
  ssr={true}
  infinite={false}
  autoPlay={false}
  rtl={true}
  autoPlaySpeed={1000}
  keyBoardControl={true}
  transitionDuration={500}
  itemClass="itemStyle"
  partialVisible={false}
>
  {_identity.map(item => (
    <div
      style={{
        width: 150,
        borderRadius: 20,
        marginRight: 10,
        overflow: 'hidden',
        boxShadow: "0px 2px 2px 1px rgba(0, 0, 0, 0.2)",
        border: identity && item.label === identity.label
          ? "5px solid #74331f"
          : "3px solid #fff"
      }}
      onClick={() => setIdentity({ label: item.label, value: item.value })}
    >
      <img
        alt=""
        src={item.image}
        style={{ objectFit: "cover", height: 100, width: 150 }}
      />
      <p className="text-center" style={{ marginTop: 15 }}>
        {item.label}
      </p>
    </div>
  ))}
</Carousel>


       {/* <div style={styles.container11}>
                    {_styles.map(item =>
                        <div style={{
                            marginLeft: 10,
                            borderRadius: 20,
                            boxShadow: "2px 2px 2px 1px rgba(0, 0, 0, 0.2)",
                            border: item.label === style.label ? "5px solid #74331f" : "3px solid #fff"
                        }}
                            onClick={() => setStyle({ label: item.label, value: item.value })}>
                            <img alt="" src={item.image} style={{ objectFit: "cover", height: 100, width: 150, borderRadius: 20, marginLeft: 0 }} />
                            <p className="text-center" style={{ marginTop: 15 }}>{item.label}</p>
                        </div>
                    )}
                </div> */}


                <div className={"mt-3 justify-content-center align-items-center text-center " + (images.length > 0 ? " mb-3" : "mb-1")}>



{generatedImages.length === 0 && (

  <Button
    onClick={async () => {
      // 1. تحقق من تسجيل الدخول
     
          if (!user || !user.customer_id) {
        handleToast("يجب تسجيل الدخول أولًا", "error");
        history.push("/ia");
        return;
      }

      // 2. تحقق من الرصيد
      const balance = parseInt(user?.ia_balance || "0");

      if (balance <= 0) {
        handleToast("رصيدك غير كافٍ لإجراء العملية", "error");
        return;
      }

      // 3. ابدأ التوليد
      await handleGenerate();

      // 4. خصم نقطة
      await decreaseCustomerBalance();
    }}
    disabled={isGenerating}
    style={{
      backgroundColor: "#74331f",
      height: 60,
      width: isMobile ? "100%" : "50%",
      alignSelf: "center",
      borderRadius: 10,
    }}
  >
 

   {isGenerating ? "نجهّز لك تصورًا أوليًا..." : "ابدأ التصميم"}
  </Button>
)}


{generatedImages.length > 0 && (
  <Button
    type="button"
onClick={() => window.location.reload()}
    style={{
      backgroundColor: '#000',
      marginTop: 5,
      color: "#fff",
      height: 50,
      width: isMobile ? '100%' : '50%',
      cursor: "pointer",
      borderRadius: 10
    }}
  >
    صورة جديدة
  </Button>
)}

{
generatedImages.length > 0 && (
  <div style={{ marginTop: 20 }}>
    <div
      style={{
        display: "flex",
        gap: 20,
        justifyContent: "center",
        flexWrap: "wrap"
      }}
    >
{generatedImages.map((img, index) => (
  <div
    key={index}
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 10,
      width: isMobile ? "100%" : "45%",  
  }}
  >
    {/* الصورة */}
    <img
      src={img}
      alt={`Generated design ${index}`}
      style={{
        width: "100%",
        borderRadius: 12,
        display: "block",
      }}
    />

    {/* الأزرار */}
    <div style={{ display: "flex", gap: 10 }}>
      <button
        onClick={() =>
          window.open(
            "https://manzilikom.com/index.php?route=product/category&path=87",
            "_blank"
          )
        }
        style={{
          background: "#000",
          color: "#fff",
          border: 0,
          padding: "8px 14px",
          borderRadius: 8,
          cursor: "pointer",
        }}
      >
        صمّم معنا
      </button>

      <button
        onClick={() => download(img)}
        style={{
          background: "#74331f",
          color: "#fff",
          border: 0,
          padding: "8px 14px",
          borderRadius: 8,
          cursor: "pointer",
        }}
      >
        تحميل الصورة
      </button>
    </div>
  </div>
))}

 </div>

    {/* hover effect */}
    <style>{`
      .genOverlay { pointer-events: none; }
      .genOverlay button { pointer-events: auto; }
      div:hover > .genOverlay { opacity: 1; }
    `}</style>
  </div>
)}


                    {isGenerating && <p className="text-muted mt-3 mb-4 text-center">
                        نرتب التفاصيل بهدوء ، لحظة من فضلك ....
                    </p>}
                    {isGenerating && <LinearProgress color="error" style={{ width: '100%', height: 5 }} />}
                </div>




                <Modal size="xl" scrollable={false} show={selectedImageIndex !== -1 || selectedHistoryImageIndex !== -1} onHide={() => hideModal()} centered>
                    {isGeneratingFurnitureMarks && <LinearProgress color="error" style={{ height: 5 }} />}
                    {!isMobile &&
                        <div style={styles.container5}>

                            <div id="similar_products" style={styles.container6}>
                                {/* <img src={logo} style={{ objectFit: 'contain', width: '100%', height: 150 }} /> */}
                                {furnituresCoordinates.length > 0 && <p className="text-center" style={{ marginTop: 0 }}>اختر أثاث من الصورة للحصول على منتجات Manzilikom المشابهة</p>}
                                {similarProducts.length > 0 ?
                                    <div style={{
                                        ...styles.container7,
                                        height: getSimilarProductsBoxHeight() - 210
                                    }}>
                                        {similarProducts.map((product: any) => <div onClick={() => window.open(product.link, '_blank')!.focus()}
                                            style={styles.container9}>
                                            <img src={product.imageUrl} style={{ objectFit: 'fill', width: '100%', height: 160 }} />
                                            <h4 style={{ textAlign: 'center' }}>{product.name}</h4>
                                            <p style={{ textAlign: 'center' }}><b>{product.priceCents / 100}</b> ريال</p>
                                            <div style={{ width: '85%', height: 1, backgroundColor: '#d1d1d1' }} />
                                        </div>
                                        )}
                                    </div>
                                    : (isSearchingSimilarProducts
                                        ? <CircularProgress style={{ alignSelf: 'center' }} color="info" />
                                        : (selectedFurniture
                                            ? <p className="text-center" style={{ marginTop: 10, color: "#a1785c" }}>لا توجد منتجات مشابهة للأثاث الذي اخترت.</p>
                                            : null
                                        )
                                    )
                                }
                            </div>
                         <div style={{
                            width: 'fit-content',
                            maxWidth: '100%',
                            margin: '0 auto',
                            position: 'relative'
                         }}>
							
							
                                <img
                                    alt=""
                                    id="imgg"
                                    ref={imgRef}
                                    style={styles.image}
                                    src={selectedHistoryImageIndex !== -1 ? customerHistoryImages[selectedHistoryImageIndex].url : images[selectedImageIndex]}
                                    onLoad={handleImageLoad}
                                />
                                {furnituresCoordinates.map((item, index) =>
                                    <a key={index} style={{
                                        height: 10,
                                        width: 10,
                                        borderRadius: 5,
                                        backgroundColor: 'white',
                                        position: 'absolute',
                                        top: item.y1 + (item.y2 - item.y1) / 2,
                                        left: item.x1 + (item.x2 + 3 - item.x1) / 2,
                                    }} href="javascript:void(0);" onClick={() => {
                                        setSmiliarProducts([])
                                        setSelectedFurniture(item)
                                        getSimilarFurniture(item.secondaryType.name, item.secondaryType.rid);
                                    }} />
                                )}
                                <div style={styles.container8}>


                                    {(isCanUpscale && upscaledImageUrl !== "") &&
                                        <Button style={{ ...styles.button1, width: 150, marginTop: 5, marginLeft: 5 }} onClick={() => {
                                            setUpScaling(true)
                                            download(upscaledImageUrl)
                                        }}>
                                            {isUpScaling
                                                ? <CircularProgress size={20} style={{ alignSelf: 'center' }} color="warning" />
                                                : "حمل دقة عالية"
                                            }
                                        </Button>
                                    }
                                    <div>
                                        <Button style={{ ...styles.button2, width: 150, marginTop: 5, marginLeft: 5 }} onClick={() => { setDownloading(true); download(selectedHistoryImageIndex !== -1 ? customerHistoryImages[selectedHistoryImageIndex].url : images[selectedImageIndex]) }}>
                                            {isDownloading
                                                ? <CircularProgress size={20} style={{ alignSelf: 'center' }} color="warning" />
                                                : "تحميل الصورة"
                                            }
                                        </Button>
                                    </div>

                                    <div>
                                        <Button
                                            onClick={() => hideModal()}
                                            style={{ ...styles.button3, width: 100 }}>
                                            <span style={{ textAlign: 'center', flex: 1 }}>إغلاق</span>
                                            <FeatherIcons style={{ height: 21, paddingTop: 2, color: "white" }} icon={'x'} className="icon-dual" />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>}

                    {isMobile &&
                        <div style={{ ...styles.container5, flexDirection: 'column' }}>

                            <div style={{ width: '100%' }}>
                                <Button
                                    onClick={() => hideModal()}
                                    style={styles.closeButton}>
                                    <FeatherIcons style={{ height: 21, paddingTop: 2, color: "black" }} icon={'x'} className="icon-dual" />
                                </Button>
                                {/* <img alt="" src={logo} style={{ objectFit: 'contain', width: '90%', height: 70, marginTop: 15, marginBottom: 15 }} /> */}
                                <img
                                    alt=""
                                    id="imgg"
                                    ref={imgRef}
                                    style={styles.image}
                                    src={selectedHistoryImageIndex !== -1 ? customerHistoryImages[selectedHistoryImageIndex].url : images[selectedImageIndex]}
                                    onLoad={handleImageLoad}
                                />
                                {furnituresCoordinates.map((item, index) =>
                                    <a key={index} style={{
                                        height: 10,
                                        width: 10,
                                        borderRadius: 5,
                                        backgroundColor: 'white',
                                        position: 'absolute',
                                        top: item.y1 + (item.y2 - item.y1) / 2 + 100,
                                        left: item.x1 + (item.x2 + 3 - item.x1) / 2,
                                    }} href="javascript:void(0);" onClick={() => {
                                        setSmiliarProducts([])
                                        setSelectedFurniture(item)
                                        getSimilarFurniture(item.secondaryType.name, item.secondaryType.rid);
                                    }} />
                                )}
                                <div style={styles.container10}>
                                    <Button style={{ ...styles.button2, width: '90%', marginBottom: 5 }} onClick={() => { setDownloading(true); download(selectedHistoryImageIndex !== -1 ? customerHistoryImages[selectedHistoryImageIndex].url : images[selectedImageIndex]) }}>
                                        {isDownloading
                                            ? <CircularProgress size={20} style={{ alignSelf: 'center', marginTop: 5 }} color="warning" />
                                            : "تحميل الصورة"
                                        }
                                    </Button>
                                    {(isCanUpscale && upscaledImageUrl !== "") &&
                                        <Button style={{ ...styles.button1, width: '90%' }} onClick={() => {
                                            if (isAlreadyUpscaled) {
                                                enqueueSnackbar("لا يمكنك التحميل مرة أخرى بدقة عالية، ارفع صورة جديدة.", { variant: "error", anchorOrigin: { vertical: 'top', horizontal: 'right' }, autoHideDuration: 5000 })

                                                return
                                            } else {
                                                setUpScaling(true)
                                                download(upscaledImageUrl)
                                            }
                                        }}>
                                            {isUpScaling
                                                ? <CircularProgress size={20} style={{ alignSelf: 'center', marginTop: 5 }} color="warning" />
                                                : "حمل دقة عالية"
                                            }
                                        </Button>
                                    }

                                </div>
                            </div>
                            <div id="similar_products" style={{ ...styles.container6, width: '100%' }}>
                                {furnituresCoordinates.length > 0 && <p className="text-center" style={{ marginTop: 10 }}>اختر أثاث من الصورة للحصول على منتجات Manzilikom المشابهة</p>}
                                {similarProducts.length > 0 ?
                                    <div style={{
                                        ...styles.container7,
                                        height: getSimilarProductsBoxHeight() - 155
                                    }}>
                                        {similarProducts.map((product: any) => <div onClick={() => window.open(product.link, '_blank')!.focus()}
                                            style={styles.container9}>
                                            <img src={product.imageUrl} style={{ objectFit: 'contain', width: '100%', height: 160 }} />
                                            <h4 style={{ textAlign: 'center' }}>{product.name}</h4>
                                            <p style={{ textAlign: 'center' }}><b>{product.priceCents / 100}</b> ريال</p>
                                            <div style={{ width: '85%', height: 1, backgroundColor: '#d1d1d1' }} />
                                        </div>
                                        )}
                                    </div>
                                    : (isSearchingSimilarProducts
                                        ? <CircularProgress style={{ alignSelf: 'center' }} color="info" />
                                        : (selectedFurniture
                                            ? <p className="text-center" style={{ marginTop: 10, color: "#a1785c" }}>لا توجد منتجات مشابهة للأثاث الذي اخترت.</p>
                                            : null
                                        )
                                    )
                                }
                            </div>
                        </div>
                    }
                </Modal>

                <Offcanvas show={showMenu} onHide={() => setShowMenu(false)} placement="end" style={{ height: '100%', width: isMobile ? '70%' : '25%' }} >
                    <Offcanvas.Header style={{
                        justifyContent: 'space-between',
                        padding: 0,
                        paddingRight: 10,
                        paddingLeft: 10
                    }}>
                        <div />
                        {/* <img src={logo} alt="" style={{ width: 100, height: 100, objectFit: 'contain' }} /> */}
                        <FeatherIcons style={{ height: 21 }} icon={'x'} className="icon-dual" onClick={() => setShowMenu(false)} />
                    </Offcanvas.Header >
                    <Offcanvas.Body>
                        {user?.shorts === "1" &&
                            <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => { setShowMenu(false); setShowAddShortsModal(true) }}>
                                <FeatherIcons style={{ height: 21, paddingLeft: 5 }} icon="video" />
                                <p style={{ fontWeight: 'bold', marginRight: 3 }}>إدارة الشورت</p>
                            </div>
                        }
                        {user?.shorts === "1" &&
                            <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => { setShowMenu(false); setShowMobileVersionModal(true) }}>
                                <FeatherIcons style={{ height: 21, paddingLeft: 5 }} icon="smartphone" />
                                <p style={{ fontWeight: 'bold', marginRight: 3 }}>نسخة تطبيق الهاتف</p>
                            </div>
                        }
                        <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => window.open("https://manzilikom.com/", "_blank")}>
                            <FeatherIcons style={{ height: 21, paddingLeft: 5 }} icon="shopping-bag" onClick={() => setShowMenu(false)} />
                            <p style={{ fontWeight: 'bold', marginRight: 3 }}>المتجر</p>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => window.open("https://manzilikom.com/index.php?route=product/product&product_id=542&search=%D8%B0%D9%83%D8%A7%D8%A1", "_blank")}>
                            <span style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 13, letterSpacing: -2, paddingLeft: 4 }}>SAR</span>
                            <p style={{ fontWeight: 'bold', marginRight: 3 }}>اشحن رصيدك</p>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => { setShowMenu(false); setShowImagesHistory(true) }}>
                            <FeatherIcons style={{ height: 21, paddingLeft: 5 }} icon="image" />
                            <p style={{ fontWeight: 'bold', marginRight: 3 }}>أرشيف الصور</p>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => { setShowMenu(false); setShowInstructions(true) }}>
                            <FeatherIcons style={{ height: 21, paddingLeft: 5 }} icon="info" onClick={() => setShowMenu(false)} />
                            <p style={{ fontWeight: 'bold', marginRight: 3 }}>تعليمات استخدام الذكاء</p>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => user ? logout() : window.location.href = "https://manzilikom.com/index.php?route=account/login"}>
                            <FeatherIcons style={{ height: 21, paddingLeft: 5 }} icon="log-out" />
                            <p style={{ fontWeight: 'bold', marginRight: 3 }}>{user ? "تسجيل الخروج" : "تسجيل الدخول"}</p>
                        </div>
                    </Offcanvas.Body>
                </Offcanvas>

                <Offcanvas show={showInstructions} onHide={() => setShowInstructions(false)} placement="bottom" style={{ height: isMobile ? '100%' : '95%', width: '100%' }} >
                    <Offcanvas.Header style={{
                        justifyContent: 'space-between',
                        padding: 10
                    }}>
                        <div />
                        <FeatherIcons style={{ height: 26, windth: 26 }} icon={'x'} className="icon-dual" onClick={() => setShowInstructions(false)} />
                    </Offcanvas.Header >
                    <Offcanvas.Body style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {/* <img src={logo} alt="" style={{ width: 200, height: 200, objectFit: 'contain' }} /> */}
                        <h2 style={{ fontWeight: 'bold', textAlign: 'center', paddingTop: isMobile ? 20 : 0, paddingBottom: 15, color: "#5D290D" }}>تعليمات استخدام الذكاء</h2>
                        <p className={"mb-2 mt-4"} style={{ fontSize: 19, paddingLeft: 10, paddingRight: 10 }}>
                            هل تواجه صعوبة في الحصول على أفكار تصميم جديدة لمساحتك ؟
                            <br /> هل تريد تصاميم تعكس شخصيتك و استقلاليتك ؟ هل أطلت البحث عن اختيارات تلبي كافة احتياجاتك؟ أو ربما لا تمتلك ميزانية كافية للاستعانة بمصمم في كافة مساحات الديكور الخاصة بك ؟
                            <br /><br />
                            الان …
                            <br /><br />
                            تصميمك أصبح أسهل، اسرع ، أمتع، و باقل كلفة ماليه وذلك مع Manzilikom( قم بمتابعتنا عبر الانستقرام لتحصل على تجربتك مجانا لعدد ٥ نقاط )
                            <br /><br />
                            ابدأ الآن تجربتك بتصميم يحقق تصوراتك وبشكل  استثنائي مع Manzilikom  وذلك بخطوات سهلة وسريعة  .
                            <br /><br />
                            قم بالتقاط صورة او بتحميل مساحتك ، وحدد نوع الغرفة و النمط . ثم انتظر ما بين دقيقتين الي ٣ دقائق لتحصل  على مجموعة من التصورات التي تقربك لتصميمك.
                            عند اختيارك للتصميم الملامس لرغباتك قم بالضغط على الصوره المختارة ليظهر لك نقاط بيضاء على الاثاث قم بالضغط عليها لتظهر لك اسعار الاثاث المتوفره لدينا من خلال متجر منزلكم و شركاؤنا ان وجدت ،  حمل الصورة بدقة عاليه ومن ثم اكمل مشوارك بالضغط على زر طلب تصميم احترافي ليقوم النظام بأعادة توجيهك لمتجر منزلكم ومن ثم اختر من خلاله ( طلب تصميم خاص - اضغط عرض سعر ) او اختر من الخيارات المتاحه بالقسم بعدها سوف يقوم فريق العمل الاحترافي لدينا بالتواصل معك لنكمل معك رحلة التصميم و إجراء أي تعديل على التصاميم وعمل المخططات التنفيذية لتسهل عليك تنفيذها بجوده عليه تتوافق مع مخططاتك الماليه .
                            لا نزال مستمرين معك في تقديم جهودنا و خدماتنا حيث ان منزلكم تقوم من خلال فريقها المختص و المحترف بتنفيذ كافة الاعمال المطلوبه بتصميمك وفق معايير هندسية وجماليه تضفي على المكان جمال يفوق تصوراتك ( اطلع على اعمالنا من خلال مواقع التواصل الاجتماعيه الموجوده اسفل صفحة المتجر ) ايضا و من خلال متجر منزلكم يمكنك الاطلاع على الاثاث الذي سوف يقترحه عليك فريق العمل لدينا حيث ان متجر منزلكم يقوم بتصنيع الاثاث محلين والطلب خارجيا  بالتعاون مع شركاؤنا من  كبار المصانع و  الشراكات و المتاجر  التي تضمن لكم جوده و معايير  عاليه .
                            <br /> نحن في منزلكم و شركاؤنا نسعى دوما بتسخير  كافة جهودنا وخبراتنا …. نكفيكم به خطوات مرهقة من العمل و الاختيار الغير جيد و الملائم للاثاث و المواد والبحث عن منفذ محترف والذي ينتج بعدم حصولكم عليه تحمل مخرجات العمل فقدان جوده وجمال وفخامة مظهر اختياراتكم لتصميمكم .
                        </p>
                    </Offcanvas.Body>
                </Offcanvas>

                <Offcanvas show={showImagesHistory} onHide={() => setShowImagesHistory(false)} placement="bottom" style={{ height: isMobile ? '100%' : '95%', width: '100%' }} >
                    <Offcanvas.Header style={{
                        justifyContent: 'space-between',
                        padding: 10
                    }}>
                        <div style={{ width: '100%' }}>
                            <div style={{ padding: 10 }}>
                                <div />
                                <FeatherIcons style={{ height: 26, windth: 26 }} icon={'x'} className="icon-dual" onClick={() => setShowImagesHistory(false)} />
                            </div >

                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                {/* <img src={logo} alt="" style={{ width: 200, height: 150, objectFit: 'contain' }} /> */}
                                <h2 style={{ fontWeight: 'bold', textAlign: 'center', paddingTop: 20, paddingBottom: 25, color: "#5D290D" }}>أرشيف الصور ({customerHistoryImages.length})</h2>
                            </div>
                        </div>

                    </Offcanvas.Header >
                    <Offcanvas.Body style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                        <Row>
                            {customerHistoryImages.map((image: any, index) =>
							
                               <Col xs={12} sm={6} md={6} lg={4} xl={4}>
                                  <img
                                      alt=""
                                      src={image.url}
                                      style={{
                                          width: '100%',
                                          height: 220,
                                          objectFit: 'contain',
                                          marginBottom: 15,
                                          borderRadius: 10,
                                          cursor: 'pointer'
                                 }} 
								
								onClick={() => {
                                  setSelectedHistoryImageIndex(index);

                                  if (image.recordId > 0) {
                                    requestImageUpScaling(image.recordId, index);
                                  }
                                }}

								/>
                            </Col>
                            )}
                        </Row>
                    </Offcanvas.Body>
                </Offcanvas>

                <Offcanvas show={showAddShortsModal} onHide={() => setShowAddShortsModal(false)} placement="bottom" style={{ height: isMobile ? '100%' : '100%', width: '100%' }} >
                    <Offcanvas.Header style={{
                        justifyContent: 'space-between',
                        padding: 10
                    }}>
                        <div style={{ width: '100%' }}>
                            <div style={{ padding: 10 }}>
                                <div />
                                <FeatherIcons style={{ height: 26, windth: 26 }} icon={'x'} className="icon-dual" onClick={() => setShowAddShortsModal(false)} />
                            </div >

                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                {/* <img src={logo} alt="" style={{ width: 200, height: 150, objectFit: 'contain' }} /> */}
                                <h2 style={{ fontWeight: 'bold', textAlign: 'center', paddingTop: 0, paddingBottom: 10, color: "#5D290D" }}>إدارة الشورت ({shorts.length})</h2>
                            </div>
                        </div>

                    </Offcanvas.Header >
                    <Offcanvas.Body style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Row>
                            <Form.Group controlId="categorySelect" className="mb-3">
                                <Form.Label>التصنيف</Form.Label>
                                <Form.Select defaultValue=""
                                    onChange={(e: any) => setCategoryId(e.target.value)}
                                >
                                    <option value="" disabled>
                                        اختر التصنيف
                                    </option>
                                    {categories.map((category: any) => (
                                        <option value={category?.category_id}>{category.name}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>

                            <FormInput
                                type="text"
                                name="link"
                                label="رابط الشورت"
                                placeholder={'أدخل رابط الشورت'}
                                onChange={(e) => setShortUrl(e.target.value)}
                                containerClass={'mb-3'}>
                            </FormInput>

                            <FormInput
                                type="text"
                                name="product_url"
                                label="رابط المنتج"
                                onChange={(e) => setProductUrl(e.target.value)}
                                placeholder={'أدخل رابط المنتج'}
                                containerClass={'mb-3'}>
                            </FormInput>

                            <div className="mb-1 text-center d-grid">
                                <Button type="submit" style={{ backgroundColor: '#74331f' }} onClick={() => saveShort()}>
                                    أضف
                                </Button>
                            </div>
                            <table style={{ marginTop: 50 }}>
                                <tr style={{ width: '100%', marginBottom: 10 }}>
                                    <td style={{ fontWeight: 'bold', color: '#74331f', fontSize: 16 }}>التصنيف</td>
                                    <td style={{ fontWeight: 'bold', color: '#74331f', fontSize: 16 }}>رابط الشورت</td>
                                    <td style={{ fontWeight: 'bold', color: '#74331f', fontSize: 16 }}>رابط المنتج</td>
                                    <td style={{ fontWeight: 'bold', color: '#74331f', fontSize: 16 }}>التاريخ</td>
                                    <td></td>
                                </tr>
                                {shorts.map((short: any) => (
                                    <tr style={{ borderWidth: 1, }}>
                                        <td style={{ fontSize: 16, paddingRight: 10 }}>{short.name}</td>
                                        <td style={{ textDecorationLine: 'underline', fontSize: 16 }}><a href={short.short_url}>{short.short_url}</a></td>
                                        <td style={{ textDecorationLine: 'underline', fontSize: 16 }}><a href={short.product_url}>{short.product_url}</a></td>
                                        <td style={{ fontSize: 16, color: 'black' }}>{!short.createdAt ? "..." : moment(short.createdAt).format("DD-MM-YYYY HH:mm")}</td>
                                        <td style={{ color: 'red', fontWeight: 'bold', textDecorationLine: 'underline', fontSize: 16 }}>
                                            <Button type="submit" style={{ backgroundColor: 'red' }} onClick={() => deleteShort(short.short_id)}>
                                                حذف
                                            </Button>

                                        </td>
                                    </tr>
                                ))}
                            </table>
                        </Row>

                    </Offcanvas.Body>

                </Offcanvas>

                <Offcanvas show={showMobileVersionModal} onHide={() => setShowMobileVersionModal(false)} placement="bottom" style={{ height: isMobile ? '100%' : '100%', width: '100%' }} >
                    <Offcanvas.Header style={{
                        justifyContent: 'space-between',
                        padding: 10
                    }}>
                        <div style={{ width: '100%' }}>
                            <div style={{ padding: 10 }}>
                                <div />
                                <FeatherIcons style={{ height: 26, windth: 26 }} icon={'x'} className="icon-dual" onClick={() => setShowMobileVersionModal(false)} />
                            </div >

                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                {/* <img src={logo} alt="" style={{ width: 200, height: 150, objectFit: 'contain' }} /> */}
                                <h2 style={{ fontWeight: 'bold', textAlign: 'center', paddingTop: 0, paddingBottom: 10, color: "#5D290D" }}>نسخة تطبيق الهاتف</h2>
                            </div>
                        </div>

                    </Offcanvas.Header >
                    <Offcanvas.Body style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Row>

                            <FormInput
                                type="text"
                                name="link"
                                label="نسخة iOS"
                                value={iosVersion}
                                placeholder={'أدخل رابط الشورت'}
                                onChange={(e) => setIosVersion(e.target.value)}
                                containerClass={'mb-3'}>
                            </FormInput>

                            <FormInput
                                type="text"
                                name="product_url"
                                label="نسخة Android"
                                value={androidVersion}
                                onChange={(e) => setAndroidVersion(e.target.value)}
                                placeholder={'أدخل رقم النسخة'}
                                containerClass={'mb-3'}>
                            </FormInput>

                            <div className="mb-1 text-center d-grid">
                                <Button type="submit" style={{ backgroundColor: '#74331f' }} onClick={() => updateMobileVersions()}>
                                    تحديث
                                </Button>
                            </div>
                        </Row>

                    </Offcanvas.Body>

</Offcanvas>

</Layout>
</>

);

};

const styles = {
    container1: { justifyContent: 'flex-start', flex: 1 },
    container2: {
        textAlign: 'right' as const,
        fontSize: 20,
        flex: 1
    },
    container3: { justifyContent: 'flex-start' },
    container5: {
        display: 'flex',
        flexDirection: 'row' as const,
        justifyContent: 'center',
    },
    container6: {
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
        width: 500
    },
    container7: {
        display: 'flex',
        flexDirection: 'row' as const,
        flexWrap: 'wrap' as const,
        overflow: 'scroll' as const,
        overflowX: 'hidden' as const,
        width: '100%'
    },
    container11: {
        display: 'flex',
        flexDirection: 'row' as const,
        overflow: 'scroll' as const,
        overflowY: 'hidden' as const,
        width: '100%',
        paddingTop: 10,
        paddingBottom: 10
    },
    container8: {
        display: 'flex',
        flexDirection: 'row' as const,
        backgroundColor: 'transparent',
        position: 'absolute' as const,
        left: 0,
        marginTop: 5
    },
    container10: {
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        marginTop: 10,
        marginBottom: 5
    },
    button1: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff',
        color: "#74331f",
        marginBottom: 5
    },
    button2: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff',
        color: "#74331f"
    },
	
    image: {
    width: '100%',
    maxWidth: 900,
    height: 'auto',
    maxHeight: '70vh',
    objectFit: 'contain' as const,
    display: 'block',
    margin: '0 auto'
    },
	
    container9: {
        width: '50%',
        padding: 10,
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center'
    },
    updateButton: {
        backgroundColor: '#fff',
        width: '100%',
        color: 'black',
        marginBottom: 5,
        border: '1px dashed #000',
        display: 'flex',
        justifyContent: 'space-between'
    },
    balanceButton: {
        backgroundColor: '#5D290D',
        border: '0px solid #000',
        fontWeight: 'bold' as const
    },
    button3: {
        backgroundColor: '#74331f',
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 5
    },
    closeButton: {
        backgroundColor: '#fff',
        color: '#74331f',
        marginTop: 5,
        border: 0
    },
    container12: {
        display: 'flex',
        flexDirection: 'row' as const,
        justifyContent: 'space-between',
        paddingLeft: 10,
        paddingRight: 10
    }
}
export default CollovGbt;